import { useState, useEffect } from "react";
import ReactTimeago from "react-timeago-i18n";
import {
  Container,
  Text,
  Grid,
  Table,
  Badge,
  Center,
  Avatar,
  Loader,
  Alert,
  Title,
} from "@mantine/core";
import { getPrompts } from "../../api";
import { useLocation } from "wouter";
import UserAvatar from "../../_Common/UserAvatar";

export default function PromptList() {
  const [, setLocation] = useLocation();
  const [prompts, setPrompts] = useState(null);

  useEffect(() => {
    getPrompts().then((data) => {
      setPrompts(data);
    });
  }, []);

  if (!prompts)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  if (prompts.length === 0)
    return (
      <Container size="lg" px={0}>
        <Alert p={80} ta="center">
          <Title mb="lg">No prompts here yet</Title>
          <Text>
            Get started by sending requests via bulk, or find prompts in the log
            you want to re-use
          </Text>
        </Alert>
      </Container>
    );

  return (
    <Container size="lg" px={0}>
      <Grid justify="space-between">
        {/* <Grid.Col span={12}>
          <Alert mb="xl">List of Prompts</Alert>
          <Text mb="sm" fw={500}>
            Request
          </Text>
        </Grid.Col> */}

        <Grid.Col span={12}>
          <Table stickyHeader stickyHeaderOffset={60}>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Title</Table.Th>
                <Table.Th>Tags</Table.Th>
                <Table.Th>Description</Table.Th>
                <Table.Th>Created</Table.Th>
                <Table.Th>Last Used</Table.Th>
                <Table.Th>Authors</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {prompts.map((p) => (
                <Table.Tr
                  key={p.id}
                  onClick={() => {
                    setLocation(`/prompts/${p.id}`);
                  }}
                >
                  <Table.Td>{p.title}</Table.Td>
                  <Table.Td>
                    {p.tags?.map((tag) => (
                      <Badge key={p.id + "tag" + tag} size="xs" mr="xs">
                        {tag}
                      </Badge>
                    ))}
                  </Table.Td>
                  <Table.Td>
                    <Text style={{ maxWidth: "15dvw" }} truncate="end">
                      {p.description ?? p.promptText}
                    </Text>
                  </Table.Td>
                  <Table.Td>{p.created}</Table.Td>
                  <Table.Td>
                    <ReactTimeago date={p.lastUsed} />
                  </Table.Td>
                  {/* TBD: separate component for multiple authors, including 
                  a) links to the respective author
                  b) hover for name
                  c) handling of images, fallback initials
                  d) show n images, then +x if more authors in total */}
                  {/*
                  author: { id: "", avatar: "", initials: "", fullName: "" }
                  */}
                  <Table.Td>
                    <Avatar.Group>
                      {p.authors?.map((p) => (
                        <UserAvatar key={p.id} profile={p} />
                      ))}
                    </Avatar.Group>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
